module.exports = __webpack_public_path__ + "static/media/hall-P10-2026.93b259c3.svg";